<div class="content" *ngIf="content">
    <div class="row p-lvl">
        <div class="col-1 number-top">
            <div class="back-number">
                <span class="number lvl-1" *ngIf="lvl1">1</span>
                <span class="number lvl-2" *ngIf="lvl2">2</span>
                <span class="number lvl-3" *ngIf="lvl3">3</span>
                <span class="number lvl-4" *ngIf="lvl4">4</span>
            </div>
        </div>
        <div class="col-8 text-top">
            <!-- <h4 class="n-tienda">Nombre de tienda</h4> -->
            <h2 class="l-tienda" *ngIf="lvl1">Emprendedor digital</h2>
            <h2 class="l-tienda" *ngIf="lvl2">Ecommerce Avanzado</h2>
            <h2 class="l-tienda" *ngIf="lvl3">Escalador Experto</h2>
            <h2 class="l-tienda" *ngIf="lvl4">Master en ventas digitales</h2>
        </div>
        <div class="col-3 como-top">
            <!-- <a href="">¿Como subir de nivel?</a> -->
            <i class="fas fa-question-circle" *ngIf="lvl1" (click)="verVideo(1)"></i>
            <i class="fas fa-question-circle" *ngIf="lvl2" (click)="verVideo(2)"></i>
            <i class="fas fa-question-circle" *ngIf="lvl3" (click)="verVideo(3)"></i>
            <i class="fas fa-question-circle" *ngIf="lvl4" (click)="verVideo(4)"></i>
        </div>
    </div>
    <hr>
    <div class="s-lvl-t">
        <h4>Tus ventajas</h4>
    </div>
    <div class="row s-lvl">
        <div class="col">
            <div class="icon">
                <i class="fas fa-shipping-fast lvl-1" *ngIf="lvl1"></i>
                <i class="fas fa-map-marker-alt lvl-2" *ngIf="lvl2"></i>
                <i class="fas fa-map-marker-alt lvl-3" *ngIf="lvl3"></i>
                <i class="fas fa-map-marker-alt lvl-4" *ngIf="lvl4"></i>
            </div>
            <div class="text">
                <span *ngIf="lvl1">Envios a más de 1.100 municipios en el país</span>
                <span *ngIf="lvl2">Punto de recolección de envíos</span>
                <span *ngIf="lvl3">Punto de recolección de envíos</span>
                <span *ngIf="lvl4">Punto de recolección de envíos</span>
            </div>
        </div>
        <div class="col">
            <div class="icon">
                <i class="fas fa-parachute-box lvl-1" *ngIf="lvl1"></i>
                <i class="fas fa-boxes lvl-2" *ngIf="lvl2"></i>
                <i class="fas fa-boxes lvl-3" *ngIf="lvl3"></i>
                <i class="fas fa-boxes lvl-4" *ngIf="lvl4"></i>
            </div>
            <div class="text">
                <span *ngIf="lvl1">Acceso a productos Dropshipping</span>
                <span *ngIf="lvl2">Proveedor de productos privado</span>
                <span *ngIf="lvl3">Proveedor de productos privado</span>
                <span *ngIf="lvl4">Proveedor de productos privado</span>
            </div>
        </div>
        <div class="col" *ngIf="lvl1">
            <div class="icon">
                <i class="fas fa-chart-line lvl-1" *ngIf="lvl1"></i>
                <!-- <i class="fas fa-headphones-alt lvl-4" *ngIf="lvl4"></i> -->
            </div>
            <div class="text">
                <span *ngIf="lvl1">Aceleración de recursos</span>
                <!-- <span *ngIf="lvl4">Soporte preferencial</span> -->
            </div>
        </div>
    </div>
    <div class="row s-lvl">
        <div class="col">
            <div class="icon">
                <i class="fas fa-comment-dots lvl-1" *ngIf="lvl1"></i>
                <i class="fas fa-comment-dots lvl-2" *ngIf="lvl2"></i>
                <i class="fas fa-comment-dots lvl-3" *ngIf="lvl3"></i>
                <i class="fas fa-comment-dots lvl-4" *ngIf="lvl4"></i>
            </div>
            <div class="text">
                <span *ngIf="lvl1">Tracking de SMS</span>
                <span *ngIf="lvl2">500 Mensajes de texto</span>
                <span *ngIf="lvl3">2000 Mensajes de texto</span>
                <span *ngIf="lvl4">5000 Mensajes de texto</span>
            </div>
        </div>
        <div class="col">
            <div class="icon">
                <i class="fas fa-hand-holding-usd lvl-1" *ngIf="lvl1"></i>
                <i class="fas fa-hand-holding-usd lvl-2" *ngIf="lvl2"></i>
                <i class="fas fa-hand-holding-usd lvl-3" *ngIf="lvl3"></i>
                <i class="fas fa-hand-holding-usd lvl-4" *ngIf="lvl4"></i>
            </div>
            <div class="text">
                <span *ngIf="lvl1">Adelantos al 2.9%</span>
                <span *ngIf="lvl2">Adelantos al 2.3%</span>
                <span *ngIf="lvl3">Adelantos al 1.8%</span>
                <span *ngIf="lvl4">Adelantos al 1.2%</span>
            </div>
        </div>
        <div class="col">
            <div class="icon">
                <i class="fab fa-shopify lvl-1" *ngIf="lvl1"></i>
                <i class="fas fa-project-diagram lvl-4" *ngIf="lvl4"></i>
            </div>
            <div class="text">
                <span *ngIf="lvl1">Conexión Shopify</span>
                <span *ngIf="lvl4">Remarketing dinámico</span>
            </div>
        </div>
    </div>
    <hr>
    <div class="t-lvl">
        <h4>¡Sube de nivel!</h4>
    </div>
    <div class="t-lvl">
        <span>Hay muchos más beneficios esperando por ti, ¡sigue creciendo!</span>
    </div>
    <div class="t-lvl">
        <button class="btn" (click)="beneficios()">Descubrir más beneficios</button>
    </div>
    <div class="t-lvl">
        <a (click)="comoSubir()">¿Como subir de nivel?</a>
    </div>
</div>
<div class="content2" *ngIf="!content">
    <div class="volver"><a (click)="volver()"><i class="fas fa-reply"></i>Volver</a></div>
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" *ngIf="benefi">
        <div class="carousel-inner">
            <!-- NIVEL 1 -->
            <div class="carousel-item" *ngIf="!lvl1" [ngClass]="{'active':activeCarr1}">
                <div class="row number-top">
                    <div class="back-number">
                        <span class="number lvl-1">1</span>
                    </div>
                </div>
                <div class="row text-top">
                    <h2 class="l-tienda">Emprendedor digital</h2>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-shipping-fast lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Envios a más de 1.100 municipios en el país</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-parachute-box lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Acceso a productos Dropshipping</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-chart-line lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Aceleración de recursos</span>
                        </div>
                    </div>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-comment-dots lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Tracking de SMS</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-hand-holding-usd lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Adelantos al 2.9%</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fab fa-shopify lvl-1"></i>
                        </div>
                        <div class="text">
                            <span>Conexión Shopify</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- NIVEL 2 -->
            <div class="carousel-item" *ngIf="!lvl2" [ngClass]="{'active':activeCarr2}">
                <div class="row number-top">
                    <div class="back-number">
                        <span class="number lvl-2">2</span>
                    </div>
                </div>
                <div class="row text-top">
                    <h2 class="l-tienda">Ecommerce Avanzado</h2>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-map-marker-alt lvl-2"></i>
                        </div>
                        <div class="text">
                            <span>Punto de recolección de envíos</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-boxes lvl-2"></i>
                        </div>
                        <div class="text">
                            <span>Proveedor de productos privado</span>
                        </div>
                    </div>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-comment-dots lvl-2"></i>
                        </div>
                        <div class="text">
                            <span>500 Mensajes de texto</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-hand-holding-usd lvl-2"></i>
                        </div>
                        <div class="text">
                            <span>Adelantos al 2.3%</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- NIVEL 3 -->
            <div class="carousel-item" *ngIf="!lvl3">
                <div class="row number-top">
                    <div class="back-number">
                        <span class="number lvl-3">3</span>
                    </div>
                </div>
                <div class="row text-top">
                    <h2 class="l-tienda">Escalador Experto</h2>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-map-marker-alt lvl-3"></i>
                        </div>
                        <div class="text">
                            <span>Punto de recolección de envíos</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-boxes lvl-3"></i>
                        </div>
                        <div class="text">
                            <span>Proveedor de productos privado</span>
                        </div>
                    </div>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-comment-dots lvl-3"></i>
                        </div>
                        <div class="text">
                            <span>2000 Mensajes de texto</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-hand-holding-usd lvl-3"></i>
                        </div>
                        <div class="text">
                            <span>Adelantos al 1.8%</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- NIVEL 4 -->
            <div class="carousel-item" *ngIf="!lvl4">
                <div class="row number-top">
                    <div class="back-number">
                        <span class="number lvl-4">4</span>
                    </div>
                </div>
                <div class="row text-top">
                    <h2 class="l-tienda">Master en ventas digitales</h2>
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-map-marker-alt lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>Punto de recolección de envíos</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-boxes lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>Proveedor de productos privado</span>
                        </div>
                    </div>
                    <!-- <div class="col">
                        <div class="icon">
                            <i class="fas fa-headphones-alt lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>Soporte preferencial</span>
                        </div>
                    </div> -->
                </div>
                <div class="row ventaj">
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-comment-dots lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>5000 Mensajes de texto</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-hand-holding-usd lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>Adelantos al 1.2%</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="icon">
                            <i class="fas fa-project-diagram lvl-4"></i>
                        </div>
                        <div class="text">
                            <span>Remarketing dinámico</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <i class="fas fa-chevron-circle-left iconCarr"></i>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <i class="fas fa-chevron-circle-right iconCarr"></i>
            <span class="sr-only">Next</span>
        </a>
    </div>
    <div class="comoLvl" *ngIf="comoNivel">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <!-- NIVEL 1 -->
                <div class="carousel-item active">
                    <h3>¿Cómo subir de nivel?</h3>
                    <p>
                        Este documento establece las condiciones generales de Triidy y su sistema de niveles que
                        permiten a los usuarios obtener determinados beneficios según su promedio de ventas trimestrales
                        con la finalidad de potenciar su crecimiento y generarles mayor valor
                        de acuerdo a su capacidad de aumentar sus ventas.
                    </p>
                    <p>
                        El sistema de niveles implica conocimiento y aceptación expresa, por parte de los usuarios, de
                        todas las condiciones establecidas en los términos y condiciones de Triidy.
                    </p>
                    <h4>1. Subir de nivel</h4>
                    <p>
                        Los usuarios suben de nivel de acuerdo con su promedio de ventas trimestrales, cada mes el
                        sistema realiza una evaluación del comportamiento de tus ventas en los últimos tres meses y
                        realizando el promedio se te asigna el nivel y los beneficios correspondientes
                        a este.
                    </p>
                </div>
                <div class="carousel-item">
                    <h4>2. Niveles</h4>
                    <p>
                        Con base al promedio de ventas trimestrales de cada tienda, los usuarios serán clasificados
                        mensualmente en diferentes niveles. La ubicación en los distintos niveles dará derecho a la
                        obtención de los beneficios propios que posee cada uno de ellos, los
                        cuáles se establecen de la siguiente manera.
                    </p>
                    <ul>
                        <!-- <li>Nivel 1 - <b>Emprendedor digital:</b> De 0 a 150 Promedio de ventas trimestrales</li>
                        <li>Nivel 2 - <b>Ecommerce Avanzado:</b> De 151 a 350 Promedio de ventas trimestrales</li>
                        <li>Nivel 3 – <b>Escalador Experto:</b> De 351 a 800 Promedio de ventas trimestrales</li>
                        <li>Nivel 4 – <b>Máster en ventas:</b> De 801 Promedio de ventas trimestrales</li> -->
                        <li>Nivel 1 - Menos de 450 ventas en un trimestre</li>
                        <li>Nivel 2 - Mas de 450 ventas en un trimestre</li>
                        <li>Nivel 3 – Mas de 1050 ventas en un trimestre</li>
                        <li>Nivel 4 – Mas de 2400 ventas en un trimestre</li>
                    </ul>
                </div>
                <div class="carousel-item">
                    <h4>3. Beneficios</h4>
                    <p>
                        Los beneficios que se establecen a continuación estarán disponibles para los usuarios que
                        pertenezcan a su respectivo nivel. Serán acumulables, por lo cual, al subir de nivel se
                        conservarán los beneficios anteriormente obtenidos por el usuario y se añadirán
                        las ventajas de su nuevo nivel. Los beneficios por nivel se encuentran detallados en la
                        siguiente tabla:
                    </p>
                    <table class="tab-mob">
                        <tr>
                            <th colspan="2">Beneficios</th>
                        </tr>
                        <tr>
                            <td>Nivel 1</td>
                            <td>
                                <ul>
                                    <li>Marketplace Dropshipping</li>
                                    <li>Envía e a más de 1.100 municipios</li>
                                    <li>Acceso a proveedores</li>
                                    <li>Adelanto de dinero al 2.9%</li>
                                    <li>Tracking de SMS</li>
                                    <li>Conexión Shopify</li>
                                    <li>Aceleración de dinero</li>
                                    <li>Reembolso de indemnizaciones</li>
                                    <li>CRM</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 2</td>
                            <td>
                                <ul>
                                    <li>Punto de recogida de mercancía</li>
                                    <li>Proveedor privado</li>
                                    <li>Adelanto de dinero al 2.3%</li>
                                    <li>500 SMS Gratis</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 3</td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.8%</li>
                                    <li>2000 SMS Gratis</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 4</td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.2%</li>
                                    <!-- <li>Soporte preferencial</li> -->
                                    <li>5000 SMS Gratis</li>
                                    <li>Remarketing dinámico</li>
                                    <li>Venta cruzada Tracking</li>
                                    <li>Indemnizaciones rápidas</li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                    <table class="tab-nav">
                        <tr>
                            <th></th>
                            <th>Nivel 1</th>
                            <th>Nivel 2</th>
                            <th>Nivel 3</th>
                            <th>Nivel 4</th>
                        </tr>
                        <tr>
                            <th>Beneficios</th>
                            <td>
                                <ul>
                                    <li>Marketplace Dropshipping</li>
                                    <li>Envía e a más de 1.100 municipios</li>
                                    <li>Acceso a proveedores</li>
                                    <li>Adelanto de dinero al 2.9%</li>
                                    <li>Tracking de SMS</li>
                                    <li>Conexión Shopify</li>
                                    <li>Aceleración de dinero</li>
                                    <li>Reembolso de indemnizaciones</li>
                                    <li>CRM</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Punto de recogida de mercancía</li>
                                    <li>Proveedor privado</li>
                                    <li>Adelanto de dinero al 2.3%</li>
                                    <li>500 SMS Gratis</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.8%</li>
                                    <li>2000 SMS Gratis</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.2%</li>
                                    <!-- <li>Soporte preferencial</li> -->
                                    <li>5000 SMS Gratis</li>
                                    <li>Remarketing dinámico</li>
                                    <li>Venta cruzada Tracking</li>
                                    <li>Indemnizaciones rápidas</li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="carousel-item">
                    <h4>4. Bajar de nivel</h4>
                    <p>
                        Los beneficios que se establecieron serán otorgados al usuario según su nivel al inicio de cada
                        mes, por lo tanto, si el Usuario es de nivel 2, pero al inicio del mes no alcanza el número de
                        ventas necesario (151 a 350 ventas), este bajara al nivel 1,
                        de esta forma el sistema de niveles es dinámico, promoviendo al usuario al alcance sus metas.
                    </p>
                    <table class="tab-mob">
                        <tr>
                            <th colspan="2">Beneficios</th>
                        </tr>
                        <tr>
                            <td>Nivel 1</td>
                            <td>
                                <ul>
                                    <li>Marketplace Dropshipping</li>
                                    <li>Envía e a más de 1.100 municipios</li>
                                    <li>Acceso a proveedores</li>
                                    <li>Adelanto de dinero al 2.9%</li>
                                    <li>Tracking de SMS</li>
                                    <li>Conexión Shopify</li>
                                    <li>Aceleración de dinero</li>
                                    <li>Reembolso de indemnizaciones</li>
                                    <li>CRM</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 2</td>
                            <td>
                                <ul>
                                    <li>Punto de recogida de mercancía</li>
                                    <li>Proveedor privado</li>
                                    <li>Adelanto de dinero al 2.3%</li>
                                    <li>500 SMS Gratis</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 3</td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.8%</li>
                                    <li>2000 SMS Gratis</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Nivel 4</td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.2%</li>
                                    <!-- <li>Soporte preferencial</li> -->
                                    <li>5000 SMS Gratis</li>
                                    <li>Remarketing dinámico</li>
                                    <li>Venta cruzada Tracking</li>
                                    <li>Indemnizaciones rápidas</li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                    <table class="tab-nav">
                        <tr>
                            <th></th>
                            <th>Nivel 1</th>
                            <th>Nivel 2</th>
                            <th>Nivel 3</th>
                            <th>Nivel 4</th>
                        </tr>
                        <tr>
                            <th>Beneficios</th>
                            <td>
                                <ul>
                                    <li>Marketplace Dropshipping</li>
                                    <li>Envía e a más de 1.100 municipios</li>
                                    <li>Acceso a proveedores</li>
                                    <li>Adelanto de dinero al 2.9%</li>
                                    <li>Tracking de SMS</li>
                                    <li>Conexión Shopify</li>
                                    <li>Aceleración de dinero</li>
                                    <li>Reembolso de indemnizaciones</li>
                                    <li>CRM</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Punto de recogida de mercancía</li>
                                    <li>Proveedor privado</li>
                                    <li>Adelanto de dinero al 2.3%</li>
                                    <li>500 SMS Gratis</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.8%</li>
                                    <li>2000 SMS Gratis</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Adelanto de dinero al 1.2%</li>
                                    <!-- <li>Soporte preferencial</li> -->
                                    <li>5000 SMS Gratis</li>
                                    <li>Remarketing dinámico</li>
                                    <li>Venta cruzada Tracking</li>
                                    <li>Indemnizaciones rápidas</li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <a class="carousel-control-prev howcarr-prev" href="#carouselExampleControls" role="button"
                data-slide="prev">
                <i class="fas fa-chevron-circle-left iconCarr"></i>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next howcarr-next" href="#carouselExampleControls" role="button"
                data-slide="next">
                <i class="fas fa-chevron-circle-right iconCarr"></i>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    <div class="video" *ngIf="videos">
        <!-- <h2>Videos {{ urlVideo }}</h2> -->
        <iframe width="560" height="315" [src]="urlVideo" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        <!-- <img src="https://www.textilperusantarosa.com/sitio-en-construccion.jpg" alt="En construcción" style="width: 60%;
    margin-left: auto;
    margin-right: auto;
    display: block;"> -->
    </div>
</div>